import { createProductFirstFiltersRequest } from "@faire/retailer-shared/categories/createRequests/createProductFirstFiltersRequest";
import { useCategoryPageFilterKeys } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageFilterKeys";
import { useRequestReferrer } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useRequestReferrer";
import { useLoggedOutCategoryPageCurrentNavigationPath } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentNavigationPath";
export var useLoggedOutCategoryPageCatNavFilterRequest = function() {
    var navigationPath = useLoggedOutCategoryPageCurrentNavigationPath();
    var filterKeys = useCategoryPageFilterKeys();
    var referrer = useRequestReferrer();
    return createProductFirstFiltersRequest({
        navigationPath: navigationPath,
        filterKeys: filterKeys,
        requestReferrer: referrer
    });
};
